export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      linkedCmsMsts: [
        {
          linkedCmsMstId: 4,
          linkedCmsMstUuid: 'linkedcms004',
          linkedCmsName: 'ボット管理CMS',
          linkedCmsCode: 'cms-xxxxx-xxxxx-xxxxx',
          linkedCmsUrl: 'https://xxx.xxx.xxx',
          linkedCmsStatus: 1
        },
        {
          linkedCmsMstId: 3,
          linkedCmsMstUuid: 'linkedcms003',
          linkedCmsName: '配信管理CMS',
          linkedCmsCode: 'cms-xxxxx-xxxxx-xxxxx',
          linkedCmsUrl: 'https://xxx.xxx.xxx',
          linkedCmsStatus: 1
        },
        {
          linkedCmsMstId: 2,
          linkedCmsMstUuid: 'linkedcms002',
          linkedCmsName: 'バス予約管理CMS',
          linkedCmsCode: 'cms-xxxxx-xxxxx-xxxxx',
          linkedCmsUrl: 'https://xxx.xxx.xxx',
          linkedCmsStatus: 1
        },
        {
          linkedCmsMstId: 1,
          linkedCmsMstUuid: 'linkedcms001',
          linkedCmsName: 'レストラン予約CMS',
          linkedCmsCode: 'cms-xxxxx-xxxxx-xxxxx',
          linkedCmsUrl: 'https://xxx.xxx.xxx',
          linkedCmsStatus: 1
        }
      ]
    }
  }
}